import React, { useState, forwardRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./common.css"; // optional for additional styling
import { FiChevronDown } from "react-icons/fi";
// Custom input component
const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-year-picker-btn"
        onClick={onClick}
        ref={ref}
    >
        {value || ""}
        <FiChevronDown style={{ marginLeft: "8px", fontSize: "16px", color: "#555" }} />
    </button>
));

const YearPicker = ({ selectedYear, setSelectedYear }) => {


    return (
        <div>
            <DatePicker
                selected={selectedYear}
                onChange={(date) => setSelectedYear(date)}
                showYearPicker
                dateFormat="yyyy"
                customInput={<CustomInput />}
            />


        </div>
    );
};

export default YearPicker;
